import { FormFormat, TemplateCategory } from '@heidi/schema/ml-scribe';

/**
 * The single decision helper for "is this template an XML form?".
 *
 * `form_format` defaults to `'pdf'` server-side and is required on every
 * template response, so a template saved before the XML work still arrives as
 * an explicit `'pdf'` and reads as PDF here.
 *
 * The input is structural so a gallery template (a different generated enum
 * for the same `'pdf' | 'xml'` values) can use the same rule as a library
 * template. Callers pass `template_content.form_format` when the gallery
 * stores the format on the content, not the root.
 *
 * Deliberately NOT flag-gated: the flag decides whether XML can be CREATED
 * and whether the community preview is shown, but a template that already
 * exists must be recognised regardless, or the library offers a PDF download
 * for a template that has no PDF.
 */
export const isXmlFormTemplate = (
  template:
    | {
        template_category?: string | null;
        form_format?: string | null;
      }
    | null
    | undefined
): boolean =>
  template?.template_category === TemplateCategory.FORM_TEMPLATE &&
  template.form_format === FormFormat.xml;

/**
 * True when the XML form rollout keeps this template off Community (flag off
 * and the template is XML), independent of `is_publishable`. Every surface
 * that offers Community publishing reads this one rule, as it does
 * `isJsonFormCommunityBlocked`.
 *
 * An XFA PDF form is not an XML form here: the backend has no Community rule
 * for it, so neither does this.
 */
export const isXmlFormCommunityBlocked = (
  template: Parameters<typeof isXmlFormTemplate>[0],
  isXmlFormEnabled: boolean
): boolean => !isXmlFormEnabled && isXmlFormTemplate(template);
